import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getAuthorizationToken } from './../helpers/storagehelper';

const ProtectedRoute: React.FC = () => {
    const isAuthenticated = Boolean(getAuthorizationToken());
     return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;

